<body>
  <div>
    <div class="top-container">
      <div class="flex justify-content-between flex-wrap " style="margin-right: 8px; margin-bottom: 20px;">
        <div class="flex align-items-center justify-content-center m-3">
          <i class="pi pi-arrow-left" style="font-size: 1rem; cursor: pointer" (click)="goBack()"></i>
        </div>

        <div *ngIf="status === 'Approved' && accessType!==3" class="acceptbtn">
          <button pButton class="btn-1 btn-contrast-1 small raised " style="margin-right: 12px;"
            (click)="openShareModal()">
            Update Partner %
          </button>
          <button pButton class="btn-1 btn-contrast-1 small raised " style="margin-right: 12px;"
            (click)="openAddBalance()" *ngIf="accessType === 0">
            Add Balance
          </button>

          <button pButton class="btn-mark-disable" (click)="openDisableModal(distributorId)">Mark as Disable</button>
        </div>

        <div *ngIf="status === 'Rejected'|| status === 'Disabled'" class="flex align-items-center justify-content-center m-2">
          <div class="m-0">
           <app-permission-wrapper permission="CanApproveRejectDistributor">
            <button pButton class="btn-1 btn-warning-1 outlined-1 small raised mr-3" (click)="showDeleteDialog()">Delete</button>
          </app-permission-wrapper>
          </div>
        </div>
        <div *ngIf="status === 'In Review'" class="flex align-items-center justify-content-center m-2">
          <div class="m-0">
            <app-permission-wrapper permission="CanApproveRejectDistributor">
              <button pButton class="btn-1 btn-warning-1 outlined-1 small raised mr-3" (click)="reject()">
                Reject
              </button>
            </app-permission-wrapper>
          </div>
          <div class="m-0">
            <app-permission-wrapper permission="CanApproveRejectDistributor">
              <button pButton class="btn-1 btn-primary btn-seconary-warning small raised" (click)="approve()">
                Approve
              </button>
            </app-permission-wrapper>
          </div>
        </div>
        <!-- Page header -->
        <div *ngIf="status === 'Submitted'" class="flex align-items-center justify-content-center m-2 top-content">
          <!-- *ngIf="status === 'Submitted'" -->
          <span class="m-0">
            <app-permission-wrapper permission="CanApproveRejectDistributor">
              <button pButton class="btn-1 btn-warning-1 outlined-1 small raised" (click)="reject()">
                Reject
              </button>
            </app-permission-wrapper>
          </span>
          <span class="m-0">
            <app-permission-wrapper permission="CanEditDistributor">
              <button pButton class="btn-2 small raised btn-contrast-1"
                (click)="editDistributor(distributorId, phoneNumber)">
                Edit
              </button>
            </app-permission-wrapper>
          </span>
          <span class="m-0">
            <div class="container">
              <app-permission-wrapper permission="CanApproveRejectDistributor">
                <button pButton class="btn-1 btn-contrast-1 small raised" (click)="inreview()">
                  Mark as review
                </button>
              </app-permission-wrapper>
            </div>
          </span>
          <span class="m-0">
            <app-permission-wrapper permission="CanApproveRejectDistributor">
              <button pButton class="btn-primary" (click)="approve()">
                Approve
              </button>
            </app-permission-wrapper>
          </span>
        </div>
      </div>
      <!-- Section -->
      <div class="card-top">
        <img [src]="imgPath" class="image" />
        <div class="text" style="padding-left: 40px">
          <div class="main-text">
            {{ businessName }}
          </div>
          <div class="secondary-text" style="padding-top: 12px">
            {{ address }}
          </div>
          <div>
              <div class="flex flex-row flex-wrap">
                <div class="flex align-items-center justify-content-center">
                  <i
                    class="pi pi-paperclip"
                    style="font-size: 12px; color: #026aa2"
                  ></i>
                </div>
                
                <div
                  class="flex align-items-center justify-content-center m-1"
                  style="
                    font-size: 14px;
                    color: #026aa2;
                    line-height: 20px;
                    cursor: pointer;
                  "
                  (click)="viewAddressProof()"
                >
                  View Address proof
                </div>
              </div>
            </div>
          <div style="width: 497px">
            <div class="row-container">
              <div class="business-details">
                <div class="owner">Business Owner</div>
                <div class="user-info">
                  <div class="icon-circle">
                    <i class="user-icon pi pi-user" style="color: #708090"></i>
                  </div>
                  <div class="username ml-2">
                    <p class="name">{{ name }}</p>
                    <p class="email">{{ ownerEmailAddress }}</p>
                  </div>
                </div>
                <div style="display: flex; gap: 20px; cursor: pointer; margin-top: 12px">
                  <div class="flex align-items-center">
                    <i class="pi pi-paperclip mr-1" style="font-size: 14px; color: #026aa2"></i>
                    <div style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewOwnerIdProof()">
                      View ID proof
                    </div>
                  </div>

                  <div class="flex align-items-center">
                    <i class="pi pi-paperclip mr-1" style="font-size: 14px; color: #026aa2"></i>
                    <div style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewOwnerCV()">
                      View CV
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="historycontain">
        
          <div class="history" (click)="displayHistory()">
            <p-button icon="pi pi-history" label="History" [rounded]="true" [text]="true" size="small" />
          </div>
          <!-- <p-dialog [(visible)]="visibleHistory" header="History" [style]="{ width: '600px', 'border-radius': '12px' }">
            <p-timeline [value]="events">
              <ng-template pTemplate="content" let-event>
                <small class="p-text-secondary">
                 <strong> {{ event.status }} </strong>
                  {{
                  event.createdBy?.name || "ABC"
                  }}</small><br />
                <small class="p-text-secondary">{{
                  event.createdOn | date
                  }}</small>
              </ng-template>
              <ng-template pTemplate="opposite" let-event>
                {{ event.status }}
              </ng-template>
              <ng-template pTemplate="opposite" let-event>
                {{ event.status }}
              </ng-template>
            </p-timeline>
          </p-dialog> -->

          <p-dialog [(visible)]="visibleHistory" header="History" [style]="{ width: '600px', 'border-radius': '12px' }">
            <p-timeline [value]="events">
              <ng-template pTemplate="content" let-event>
                <small class="p-text-secondary">
                  <strong> {{ event.status }} </strong>
                  {{
                  event.createdBy?.name || ''
                  }}</small>
                <small class="p-text-secondary">{{
                  event.createdOn | date
                  }}</small>
              </ng-template>
            </p-timeline>
            <ng-template pTemplate="footer">
              <button pButton type="button" label="OK" (click)="visibleHistory = false" class="btn-primary"></button>
            </ng-template>
          </p-dialog>

          <div class="flex justify-content-center flex-wrap p-1">
            <span class="tag" [ngClass]="{
                  submitted: status === 'Submitted',
                  approved: status === 'Approved',
                  inreview: status === 'In Review',
                  rejected: status === 'Rejected'
                }">{{ status }}</span>
          </div>
        </div>
      </div>

      <div *ngIf="status === 'Rejected'" class="rejection-note-card">
        <h3>Rejection Note</h3>
        <p>{{ rejectionNote }}</p>
      </div>

      <div *ngIf="status === 'Approved'" class="snapshots-container">
        <div class="snapshot-card">
          <h4>Total services done</h4>
          <p>0</p>
        </div>
        <div class="snapshot-card">
          <h4>Total revenue earned</h4>
          <p>0</p>
        </div>
        <div class="snapshot-card">
          <h4>Total Service Seekers served</h4>
          <p>0</p>
        </div>
      </div>
    </div>
    <div class="main-part">
      <div style="padding-left: 49px; padding-right: 49px;">
        <p style="font-weight: 500; font-size: 18px; margin-bottom: 40px">
          Business Details
        </p>
        <div class="flex justify-content-between flex-wrap">
          <div class="">
            <div style="width: 225px">
              <p class="business-type-label">Year of commencement</p>
              <p class="business-type-value">{{ commencementYear }}</p>
            </div>
            <div class="business-info">
              <p class="business-type-label">Dealership Website</p>
              <!-- <p class="business-type-web" pTooltip="{{ website }}" tooltipPosition="top">
                {{ truncatedwebsite }}
              </p> -->
              <a class="business-type-web no-underline"
                [href]="website.startsWith('http') ? website : 'https://' + website" target="_blank"
                rel="noopener noreferrer" pTooltip="{{ website }}" tooltipPosition="top">
                {{ truncatedwebsite }}
                <i class="pi pi-link"></i>
              </a>

            </div>
            <div class="business-info">
              <p class="business-type-label">Authorized dealership (Manufacturer) Website</p>
              <!-- <p class="business-type-web" pTooltip="{{ authorisedDelarshipProofUrl }}" tooltipPosition="top">
                {{ truncatedauthorisedDelarshipProofUrl }}
              </p> -->
              <a class="business-type-web no-underline"
                [href]="authorisedDelarshipProofUrl.startsWith('http') ? authorisedDelarshipProofUrl : 'https://' + authorisedDelarshipProofUrl"
                target="_blank" rel="noopener noreferrer" pTooltip="{{ authorisedDelarshipProofUrl }}"
                tooltipPosition="top">
                {{ truncatedauthorisedDelarshipProofUrl }}
                <i class="pi pi-link"></i>
              </a>

            </div>
          </div>
          <div style="padding-left: 52px">
            <div>
              <p class="business-type-label">Commercial registration number</p>
              <div style="cursor: pointer">
                <div class="flex flex-row flex-wrap">
                  <p class="business-type-value">{{ commercialRegistrationNumber }}</p>
                  <div class="flex align-items-center justify-content-center ml-2">
                    <i class="pi pi-paperclip" style="font-size: 14px; color: #026aa2">
                    </i>
                  </div>
                  <!-- Certificate of incorporation documents here from serviceProviderDocuments which has documentTypeId 6-->
                  <div class="flex align-items-center justify-content-center ml-1"
                    style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewCRNProof()">
                    View proof
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="business-info">
                <p class="business-type-label">GST Number</p>
                <p class="business-type-value">{{ gst }}</p>
              </div>
            </div>

          </div>
          <div style="padding-left: 52px">
            <div>
              <p class="business-type-label">Certification of Incorporation</p>
              <div style="cursor: pointer">
                <div class="flex flex-row flex-wrap">
                  <!-- <p class="business-type-value">{{ documentName }}</p> -->
                  <span class="certificate-name" *ngIf="coiDocument?.documentName">
                    <p class="business-type-value">{{ coiDocument?.documentName }}</p>
                  </span>
                  <div class="flex align-items-center justify-content-center ml-2">
                    <i class="pi pi-paperclip" style="font-size: 14px; color: #026aa2">
                    </i>
                  </div>
                  <!-- Certificate of incorporation documents here from serviceProviderDocuments which has documentTypeId 6-->
                  <div class="flex align-items-center justify-content-center ml-1"
                    style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewCOIProof()">
                    View proof
                  </div>
                </div>
              </div>
            </div>
            <div class="business-info">
              <div>
                <p class="business-type-label">Insurance of dealership Proof</p>
                <div style="cursor: pointer">
                  <div class="flex flex-row flex-wrap">
                    <!-- <p class="business-type-value">{{ documentName }}</p> -->
                    <span class="certificate-name" *ngIf="iodDocument?.documentName">
                      <p class="business-type-value">{{ iodDocument?.documentName }}</p>
                    </span>
                    <div class="flex align-items-center justify-content-center ml-2">
                      <i class="pi pi-paperclip" style="font-size: 14px; color: #026aa2">
                      </i>
                    </div>
                    <!-- Certificate of incorporation documents here from serviceProviderDocuments which has documentTypeId 6-->
                    <div class="flex align-items-center justify-content-center ml-1"
                      style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewIODProof()">
                      View proof
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="main-part" *ngIf="status === 'Accepted' || status === 'Rejected'">
      <div style="padding-left: 49px">
        <div class="flex justify-content-start flex-wrap">
          <div style="width: 225px;"> 
            <div>
              <p class="business-type-label">Agreement DOC</p>
              <div style="cursor: pointer">
                <div class="flex flex-row flex-wrap agreement">
                  <div class="flex align-items-center justify-content-center">
                    <i class="pi pi-download" style="font-size: 14px; color: #026aa2">
                    </i>
                  </div>
                  <div class="flex align-items-center justify-content-center ml-1  "
                    style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewAgreement()">
                    View
                  </div>
                  <!-- *ngIf="agreementFileUrl" -->
                </div>
              </div>
            </div>
            <div class="business-info"></div>
          </div>
        </div>
      </div>
    </div>


    <div class="main-part">
      <div style="padding-left: 49px ">
        <p style="font-weight: 500; font-size: 16px; margin-bottom: 40px">
          Business Networks ({{ getBusinessNetworks() }})
        </p>

        <div class="flex justify-content-start flex-wrap">
          <div *ngFor="let network of distributorNetworks" class="network-container">
            <p class="business-type-label">{{ network.name }}</p>

            <div class="subtype-container flex flex-wrap justify-content-between">
              <div *ngFor="let subtype of network.distributorNetworkSubTypes" class="subtype-card">
                <p class="subtype-name">{{ subtype.name }}</p>
                <p class="subtype-count">{{ subtype.count }}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- settings modal -->
    <p-dialog [(visible)]="reviewModal" modal="true" [closable]="true" [style]="{ width: '600px' }"
      [baseZIndex]="10000">

      <ng-template pTemplate="header">
        <span class="review-heading">Mark for Review</span>
      </ng-template>

      <app-review-modal [resourceTypeLabel]="'Service distributor'" [resourceType]="'SERVICEDISTRIBUTOR'"
        (closeModal)="closeReviewModal()" (onReviewSuccess)="markForReview()"  (refreshList)="refreshAfterReview()"  >
      </app-review-modal>

    </p-dialog>


    <div>
      <p-dialog [(visible)]="visible" modal="true" [closable]="true" [style]="{ width: '600px' }" [baseZIndex]="10000">

        <ng-template pTemplate="header">
          <span class="review-heading">Approve Application </span>
        </ng-template>
        <app-custom-dialog (closeModal)="closeApproveModal()" (refreshList)="refreshDetails()"
          [resourceType]="'SERVICEDISTRIBUTOR'"></app-custom-dialog>
      </p-dialog>
    </div>
    <div>
      <p-dialog [(visible)]="visibleReject" modal="true" [closable]="true" [style]="{ width: '600px' }"
        [baseZIndex]="10000">

        <ng-template pTemplate="header">
          <span class="review-heading"> Reject Application </span>
        </ng-template>

        <app-reject-modal [resourceType]="'SERVICEDISTRIBUTOR'" (closeModal)="closeRejectModal()"
          (refreshList)="getServiceDistributorDetailsById()" [resourceTypeLabel]="'Service distributor'"
          (onUpdateServiceDistributorList)="closeRejectModal()"></app-reject-modal>

      </p-dialog>
    </div>

    <p-dialog [(visible)]="visibleViewer" [modal]="true" [style]="{ width: '90vw', height: '90vh' }" [closable]="true"
      (onHide)="closeViewer()">
      <ng-template pTemplate="content">
        <ngx-extended-pdf-viewer *ngIf="selectedDocumentUrl && isPdf(selectedDocumentUrl)" [src]="selectedDocumentUrl"
          useBrowserLocale="true" height="100%" [showSidebarButton]="false" [showToolbar]="false">
        </ngx-extended-pdf-viewer>

        <div *ngIf="selectedDocumentUrl && !isPdf(selectedDocumentUrl)" class="flex justify-content-center">
          <img [src]="selectedDocumentUrl" alt="Document" style="max-width: 100%; max-height: 90vh;" />
        </div>
      </ng-template>
    </p-dialog>


  </div>
</body>
<div>
  <app-add-distributor *ngIf="showModal" [id]="idToEdit" [phoneNumber]="phoneNumber"></app-add-distributor>

  <!-- settings modal -->
  <p-dialog [(visible)]="showSettingsModal" header=" Update Partner %  " [modal]="true" [style]="{ width: '600px' }"
    [closable]="true" [dismissableMask]="true" (onHide)="resetShareEditingState()">

    <div class="p-fluid">
      <div *ngFor="let share of sharesList; let i = index"
        class="p-field flex align-items-center justify-content-between mb-3">
        <div class="col-6">
          <label>{{ share.name }}</label>
        </div>

        <div class="col-4">
          <ng-container *ngIf="!share.isEditing">
            <span>{{ share.share }}</span>
          </ng-container>

          <ng-container *ngIf="share.isEditing">
            <input [type]="share.key === 'taxName' ? 'text' : 'number'" [(ngModel)]="share.share" pInputText
              style="width: 120px;" [placeholder]="share.key === 'taxName' ? 'Enter tax name' : ''" />
          </ng-container>
        </div>

        <div class="col-2 text-right">
          <i class="pi pi-pencil" style="cursor: pointer;" *ngIf="!share.isEditing" (click)="enableEdit(i)"></i>
          <i class="pi pi-check" style="cursor: pointer;" *ngIf="share.isEditing" (click)="disableEdit(i)"></i>
        </div>
      </div>

      <!-- <span [pTooltip]="'Enter Tax Name to enable Save'" tooltipPosition="top" *ngIf="isSaveDisabled()">
        <button pButton type="button" label="Save" class="p-button-success" [disabled]="true"></button>
      </span>

      <button *ngIf="!isSaveDisabled()" pButton type="button" label="Save" class="p-button-success"
        (click)="saveShares()"></button> -->

      <div class="footer flex justify-content-end gap-2">
        <button pButton type="button" label="Cancel" class="btn btn-cancel"
          (click)="showSettingsModal = false"></button>

        <span *ngIf="isSaveDisabled()" [pTooltip]="'Enter Tax Name to enable Save'" tooltipPosition="top">
          <button pButton type="button" label="Save" class="p-button-success btn-primary" [disabled]="true"></button>
        </span>

        <button *ngIf="!isSaveDisabled()" pButton type="button" label="Save" class="p-button-success btn btn-primary"
          (click)="saveShares()"></button>
      </div>

    </div>

  </p-dialog>
  <app-add-balance *ngIf="addBalanceModal" (close)="addBalanceModal=false" [distributorId]="distributorId"
    [calledFrom]="'service-distributor-details'"></app-add-balance>

</div>

 <p-dialog
  header="Confirm Deletion"
  [(visible)]="visibleDelete"
  modal="true"
  [closable]="true"
  [style]="{ width: '600px' }"
  [baseZIndex]="10000"
>
  <p>Are you sure you want to delete?</p>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel"  (click)="visibleDelete = false" class="btn btn-cancel"></button>
    <button pButton type="button" label="Delete"  (click)="delete()" class="btn delete-btn "></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="disableModalVisible"
  modal="true"
  [style]="{ width: '600px' }"
  [baseZIndex]="10000"
  header="Mark as disabled?"
>
  <app-mark-disable
   [distributorName]="selectedDistributorDetails.name"
    [address]="selectedDistributorDetails.address"
    [totalSpCount]="selectedDistributorDetails.totalSpCount"
    [totalCustomerCount]="selectedDistributorDetails.totalCustomerCount"
    [distributors]="availableDistributors"
    [distributorId]="selectedDistributorDetails.distributorId"
    (closeModal)="closeDisableModal()"
    (refreshList)="loadDistributorDetails()"
  ></app-mark-disable>
</p-dialog>

